import React from 'react';
import { motion } from 'framer-motion';
import './FullTeam.css';
import teamHero from '../../assets/Team/Hero.png'; 
import teamDesk from '../../assets/Team/SubHero.png';
import HomeCTA from '../HomeCTA/HomeCTA';

const teamMembers = [
  { name: "Rahul Mahato", role: "Green Hydrogen Solutions", img: "https://dazbog.ascentbw.com/Team/Rectangle.png" },
  { name: "Sourav Prakash", role: "Wind Energy Advisory & BI", img: "https://dazbog.ascentbw.com/Team/Rectangle%20(1).png" },
  { name: "Anand Prakash", role: "Solar Energy Solutions", img: "https://dazbog.ascentbw.com/Team/Rectangle%20(2).png" },
  { name: "Silva Balan", role: "Senior Manager - Design", img: "https://dazbog.ascentbw.com/Team/Rectangle%20(3).png" },
  { name: "Ramesh Sawant", role: "Electrical Designer", img: "https://dazbog.ascentbw.com/Team/Rectangle%20(4).png" },
  { name: "Sanjeev Vashist", role: "Accounts Head", img: "https://dazbog.ascentbw.com/Team/Rectangle%20(5).png" },
  { name: "Pulkit Kashyap", role: "Financial Analyst", img: "https://dazbog.ascentbw.com/Team/Rectangle%20(6).png" },
  { name: "Shubranshu Tarai", role: "Electrical Designer", img: "https://dazbog.ascentbw.com/Team/Rectangle%20(7).png" },
  { name: "Chanakya Dash", role: "Electrical Engineer", img: "https://dazbog.ascentbw.com/Team/Rectangle%20(8).png" },
  { name: "Rajaram Behera", role: "Business Development", img: "https://dazbog.ascentbw.com/Team/Rectangle%20(9).png" },
  { name: "Shubham Satapathy", role: "Project Engineer", img: "https://dazbog.ascentbw.com/Team/Rectangle%20(10).png" },
];

const FullTeam = () => {
  const fadeInUp = {
    hidden: { opacity: 0, y: 40 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.8, ease: "easeOut" } }
  };

  const staggerContainer = {
    hidden: { opacity: 0 },
    visible: { opacity: 1, transition: { staggerChildren: 0.1 } }
  };

  return (
    <div className="full-team-page">
      {/* Hero Section with Split Background & 2-Column Header */}
      <section className="team-hero-wrapper">
        <div className="container">
          {/* Top Row: Title on Left, Description on Right (like Service Details page) */}
          <div className="team-hero-top-row">
            <motion.div
              className="team-hero-title-col"
              initial={{ opacity: 0, y: -20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.7, ease: [0.25, 0.1, 0.25, 1] }}
            >
              <h1 className="team-main-heading">Our Team</h1>
            </motion.div>

            <motion.div
              className="team-hero-action-col"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.7, delay: 0.1, ease: [0.25, 0.1, 0.25, 1] }}
            >
              <p className="team-hero-tagline">
                Our team brings together experts in renewable energy, finance, engineering, and project execution, working closely to deliver reliable clean energy projects.
              </p>
            </motion.div>
          </div>

          <motion.div
            className="team-hero-img-box"
            initial={{ opacity: 0, scale: 0.95 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 1 }}
          >
            <img src={teamHero} alt="Dazbog Team" className="team-banner-img" />
          </motion.div>
        </div>
      </section>

      {/* Meet the Team Grid Section */}
      <section className="team-grid-container">
        <div className="container">
          <motion.div className="grid-heading-box" initial="hidden" whileInView="visible" viewport={{ once: true }} variants={fadeInUp}>
            <h2>Meet the Dazbog Team</h2>
            <p>Our team includes professionals from renewable energy, finance, engineering, and project execution.</p>
          </motion.div>

          <motion.div className="team-members-grid" variants={staggerContainer} initial="hidden" whileInView="visible" viewport={{ once: true, amount: 0.1 }}>
            {teamMembers.map((member, index) => (
              <motion.div key={index} className="team-profile-card" variants={fadeInUp}>
                <div className="team-img-wrapper">
                  <img src={member.img} alt={member.name} />
                  {/* Badge at right corner position */}
                  <div className="member-label-badge">
                    <h4>{member.name}</h4>
                    <p>{member.role}</p>
                  </div>
                </div>
              </motion.div>
            ))}
          </motion.div>
        </div>
      </section>

      {/* Why Our Team Matters Feature Section */}
      <section className="team-impact-section">
        <div className="container">
          <div className="impact-flex-row">
            <motion.div className="impact-visual" initial={{ opacity: 0, x: -50 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true }} transition={{ duration: 0.8 }}>
              <img src={teamDesk} alt="Team Planning" />
            </motion.div>
            <motion.div className="impact-content" initial={{ opacity: 0, x: 50 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true }} transition={{ duration: 0.8 }}>
              <h2>Why Our Team Matters</h2>
              <p>Dazbog's team combines experience in renewable energy, finance, engineering, and project execution.</p>
              <ul className="impact-check-list">
                <li>Strong experience in renewable energy projects</li>
                <li>Clear and practical technical advice</li>
                <li>Support that meets bank and lender requirements</li>
                <li>Close coordination with developers, EPCs, and investors</li>
                <li>On-ground understanding of project execution</li>
                <li>Focus on reliable, long-term project outcomes</li>
              </ul>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Replaced with Home CTA Section */}
      <HomeCTA />
    </div>
  );
};

export default FullTeam;